import { buttonStyles } from "@/components/ui/button.tsx";
import { PageTitle } from "@packages/core-client/components/PageTitle.tsx";
import { useEnvironmentVariable } from "@squide/firefly";
import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { i18NextInstanceKey } from "../i18next.ts";

export function OrganizationAccessPage() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("OrganizationAccessPage", { i18n: i18nextInstance });
    const workleapClassicUrl = useEnvironmentVariable("workleapClassicUrl");

    return (
        <div className="bg-bg text-fg flex min-h-screen flex-col items-center justify-center px-6 text-center">
            <title>{`Workleap - ${t("title")}`}</title>
            <PageTitle data-public>{t("heading")}</PageTitle>
            <p className="text-muted-fg mt-2 max-w-md text-sm leading-normal" data-public>
                {t("body")}
            </p>
            <a href={workleapClassicUrl} className={`${buttonStyles({ intent: "primary" })} mt-6`} data-public>
                {t("backToWorkleap")}
            </a>
        </div>
    );
}
